/* Floodlight · ss-core.js (core) — SS namespace, events, money, fetch, overlays, toast, section lifecycle */
(function () {
  'use strict';
  if (window.SS_LOADED_core) return;
  window.SS_LOADED_core = true;

  var doc = document;
  var html = doc.documentElement;
  var C = window.SSConfig || {};
  var SS = window.SS = window.SS || {};
  SS.config = C;
  SS.design = !!C.designMode;
  SS.domReady = doc.readyState === 'complete';
  doc.addEventListener('DOMContentLoaded', function () { SS.domReady = true; });

  SS.qs = function (sel, el) { return (el || doc).querySelector(sel); };
  SS.qsa = function (sel, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(sel)); };
  SS.str = function (key, fallback) { return (C.strings && C.strings[key]) || fallback || ''; };

  /* events: handler(detail, event); detail.detail === detail so fn(e){ e.detail.x } also works */
  SS.on = function (name, fn) {
    if (!fn.__ssWrap) {
      fn.__ssWrap = function (e) {
        var d = e.detail;
        if (!d || typeof d !== 'object') d = {};
        try { if (!('detail' in d)) Object.defineProperty(d, 'detail', { value: d, enumerable: false }); } catch (err) {}
        fn(d, e);
      };
    }
    doc.addEventListener('ss:' + name, fn.__ssWrap);
  };
  SS.off = function (name, fn) { if (fn.__ssWrap) doc.removeEventListener('ss:' + name, fn.__ssWrap); };
  SS.emit = function (name, detail) {
    var ev;
    try { ev = new CustomEvent('ss:' + name, { detail: detail || {} }); }
    catch (e) { ev = doc.createEvent('CustomEvent'); ev.initCustomEvent('ss:' + name, false, false, detail || {}); }
    doc.dispatchEvent(ev);
  };

  /* reduced motion (live) */
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  SS.reduced = !!(mq && mq.matches);
  if (mq) {
    var onMq = function () { SS.reduced = mq.matches; SS.emit('motion', { reduced: SS.reduced }); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }

  /* money: shop format, trailing zeros removed, "Rs." shown as "Rs " */
  function group(num, dec, thou, point) {
    var parts = Number(num).toFixed(dec).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts[1] ? whole + point + parts[1] : whole;
  }
  SS.money = function (cents) {
    var c = Math.round(Number(cents) || 0);
    var fmt = C.moneyFormat || 'Rs.{{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var n = c / 100;
    var v;
    switch (key) {
      case 'amount_no_decimals': v = group(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = group(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = group(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = group(n, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = group(n, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = group(n, 2, ' ', ','); break;
      default: v = group(n, 2, ',', '.');
    }
    if (c % 100 === 0) v = v.replace(/[.,]00$/, '');
    var out = fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
    return out.replace('Rs. ', 'Rs.').replace('Rs.', 'Rs ');
  };

  /* fetch helper: JSON in/out, throws {status, message, description} */
  SS.fetchJSON = function (url, opts) {
    opts = opts || {};
    var init = { method: opts.method || 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: opts.signal };
    if (opts.body !== undefined) {
      if (typeof FormData !== 'undefined' && opts.body instanceof FormData) init.body = opts.body;
      else { init.body = JSON.stringify(opts.body); init.headers['Content-Type'] = 'application/json'; }
      init.headers['X-Requested-With'] = 'XMLHttpRequest';
    }
    return fetch(url, init).then(function (res) {
      return res.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || res.statusText || 'Request failed');
          err.status = res.status;
          err.description = data && (data.description || data.message);
          throw err;
        }
        return data;
      });
    });
  };

  /* overlays: one open at a time, scrim = previous sibling, focus trap, Esc, focus return, scroll lock */
  var current = null;
  var returnTo = null;
  function byId(id) { return id ? doc.getElementById(id) : null; }
  function scrimOf(el) {
    var s = el && el.previousElementSibling;
    return s && s.classList.contains('scrim') ? s : null;
  }
  function focusables(el) {
    return SS.qsa('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(function (x) {
      return !x.disabled && x.getAttribute('aria-hidden') !== 'true' && x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden';
    });
  }
  function setExpanded(id, on) {
    SS.qsa('[aria-controls="' + id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  SS.overlay = {
    current: function () { return current; },
    open: function (id, opts) {
      opts = opts || {};
      var el = byId(id);
      if (!el) return;
      if (current === id) return;
      if (current) SS.overlay.close(current, { keepFocus: true });
      else returnTo = opts.trigger || doc.activeElement;
      if (SS.toast.hide) SS.toast.hide();
      el.hidden = false;
      var s = scrimOf(el);
      if (s) s.hidden = false;
      current = id;
      html.classList.add('ov-open');
      setExpanded(id, true);
      var target = el.querySelector('[data-autofocus]') || el.querySelector('input:not([type="hidden"])') || focusables(el)[0];
      try { if (target) target.focus({ preventScroll: true }); } catch (e) {}
      SS.emit('overlay:open', { id: id, el: el });
    },
    close: function (id, opts) {
      opts = opts || {};
      id = id || current;
      var el = byId(id);
      if (!el || el.hidden) { if (current === id) current = null; return; }
      el.hidden = true;
      var s = scrimOf(el);
      if (s) s.hidden = true;
      if (current === id) current = null;
      setExpanded(id, false);
      if (!current) html.classList.remove('ov-open');
      if (!opts.keepFocus && !current) {
        var r = returnTo;
        returnTo = null;
        try { if (r && r.isConnected && r.focus) r.focus({ preventScroll: true }); } catch (e) {}
      }
      SS.emit('overlay:close', { id: id, el: el });
    },
    closeAll: function () { if (current) SS.overlay.close(current); }
  };

  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var opener = t.closest('[data-open-overlay]');
    if (opener) {
      e.preventDefault();
      SS.overlay.open(opener.getAttribute('data-open-overlay'), { trigger: opener });
      return;
    }
    var closer = t.closest('[data-close-overlay]');
    if (closer) {
      e.preventDefault();
      var dlg = closer.closest('[role="dialog"]');
      SS.overlay.close(dlg && dlg.id ? dlg.id : current);
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (!current) return;
    var el = byId(current);
    if (!el) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      SS.overlay.close(current);
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(el);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], act = doc.activeElement;
    if (!el.contains(act)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && act === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && act === last) { e.preventDefault(); first.focus(); }
  });

  /* toast */
  var toastT = 0;
  SS.toast = function (text, opts) {
    opts = opts || {};
    var box = byId('ss-toast');
    if (!box) return;
    clearTimeout(toastT);
    box.innerHTML = '';
    var span = doc.createElement('span');
    span.textContent = text;
    box.appendChild(span);
    var cta = opts.cta || SS.str('close', 'Close');
    var btn;
    if (opts.href) {
      btn = doc.createElement('a');
      btn.href = opts.href;
      if (/^https?:/.test(opts.href) && opts.href.indexOf(location.host) < 0) { btn.target = '_blank'; btn.rel = 'noopener'; }
    } else {
      btn = doc.createElement('button');
      btn.type = 'button';
    }
    btn.className = 'link';
    btn.textContent = cta;
    btn.addEventListener('click', function (ev) {
      if (opts.onClick) opts.onClick(ev);
      if (!opts.href) SS.toast.hide();
    });
    box.appendChild(btn);
    box.hidden = false;
    box.style.animation = 'none';
    void box.offsetWidth;
    box.style.animation = '';
    var ms = opts.timeout == null ? 4200 : opts.timeout;
    if (ms > 0) toastT = setTimeout(SS.toast.hide, ms);
    SS.emit('wa:check', {});
  };
  SS.toast.hide = function () {
    clearTimeout(toastT);
    var box = byId('ss-toast');
    if (box) { box.hidden = true; box.innerHTML = ''; }
    SS.emit('wa:check', {});
  };

  /* WhatsApp link */
  SS.waLink = function (text) {
    var wa = C.wa || {};
    var digits = String(wa.digits || '').replace(/\D/g, '');
    return 'https://wa.me/' + digits + '?text=' + encodeURIComponent(text || wa.message || '');
  };

  /* IntersectionObserver helper: fn(isVisible, entry); returns a stop function */
  SS.onVisible = function (el, fn, opts) {
    if (!el) return function () {};
    if (!('IntersectionObserver' in window)) { fn(true, null); return function () {}; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { fn(en.isIntersecting, en); });
    }, opts || { rootMargin: '120px 0px' });
    io.observe(el);
    return function () { io.disconnect(); };
  };

  /* section lifecycle: init(sectionEl) after all deferred scripts ran, and again on theme-editor reloads */
  var registry = {};
  function runInit(el, init) {
    el.__ssInits = el.__ssInits || [];
    if (el.__ssInits.indexOf(init) >= 0) return;
    el.__ssInits.push(init);
    try {
      var destroy = init(el);
      if (typeof destroy === 'function') (el.__ssDestroy = el.__ssDestroy || []).push(destroy);
    } catch (err) { if (window.console) console.error('[SS] init failed for', el.getAttribute('data-section-type'), err); }
  }
  function initWithin(scope) {
    var els = SS.qsa('[data-section-type]', scope);
    if (scope !== doc && scope.hasAttribute && scope.hasAttribute('data-section-type')) els.unshift(scope);
    els.forEach(function (el) {
      (registry[el.getAttribute('data-section-type')] || []).forEach(function (init) { runInit(el, init); });
    });
    return els;
  }
  SS.sectionReady = function (type, init) {
    (registry[type] = registry[type] || []).push(init);
    var go = function () {
      SS.qsa('[data-section-type="' + type + '"]').forEach(function (el) { runInit(el, init); });
    };
    if (SS.domReady) go(); else doc.addEventListener('DOMContentLoaded', go);
  };
  doc.addEventListener('shopify:section:load', function (e) {
    var els = initWithin(e.target);
    els.forEach(function (el) { SS.emit('section:load', { el: el, type: el.getAttribute('data-section-type') }); });
  });
  doc.addEventListener('shopify:section:unload', function (e) {
    var els = SS.qsa('[data-section-type]', e.target);
    els.forEach(function (el) {
      (el.__ssDestroy || []).forEach(function (fn) { try { fn(); } catch (err) {} });
      el.__ssDestroy = [];
      SS.emit('section:unload', { el: el, type: el.getAttribute('data-section-type') });
    });
    if (current && e.target.contains(byId(current))) { current = null; html.classList.remove('ov-open'); }
  });
})();
